import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { ErrorOption } from 'react-hook-form'
import { postAkairosPreview } from '~/lib/handle-api'

import useAlerts from '~/hooks/useAlerts'
import useLocale from '~/hooks/useLocale'
import useOnMutationError from '~/hooks/useOnMutationError'

import { getLabelSizeFromSku } from '~/utils/get-label-size-from-sku'

export default function usePostPreview(
  mutationOptions?: UseMutationOptions<any, any, any>,
  setError?: (name?: string, error?: ErrorOption) => void,
) {
  const locale = useLocale()
  const triggerAlert = useAlerts()
  const onMutationError = useOnMutationError(setError)
  return useMutation<any, any, any>(
    async (data: any) => {
      const previewData = await postAkairosPreview({
        payload: {
          customData: {
            // We must provide the size of the label we are customizing, even if we are already providing the label sku
            labelSize:
              getLabelSizeFromSku(data?.variant?.sku)?.toLowerCase() ?? '',
            rawTitle: data?.title,
            rawSubtitle: data?.subtitle,
            computeSubtitleFirst: data?.computeSubtitleFirst ?? false,
            ...(data?.variant?.sku ? { labelSku: data?.variant?.sku } : {}),
          },
        },
        queryParams: {
          locale,
        },
      })

      return previewData?.data?.customData ?? null
    },
    {
      ...mutationOptions,
      onSuccess: async (data, ...rest) => {
        //! standardize error response
        const error = data?.errors?.[0]
        const errorPayload = { payload: [data?.errors?.[0]] }

        if (error) {
          return onMutationError(errorPayload, rest, mutationOptions?.onError)
        }

        mutationOptions?.onSuccess(data, ...rest)
      },
      onError: (err, ...rest) => {
        triggerAlert('CUSTOMIZATION_ERROR')
      },
    },
  )
}
